import { defineMessages } from 'react-intl';

const messages = defineMessages({
  awaitingPaymentSectionAriaLabel: {
    defaultMessage: 'Awaiting payment section',
    description: 'Aria label for the section with a message informing the user that the shipment is awaiting payment',
    id: 'nZ/Ioh',
  },
  cancelledSectionAriaLabel: {
    defaultMessage: 'Cancelled section',
    description: 'Aria label for the section with a message informing the user that the shipment has been cancelled',
    id: '/W+wCr',
  },
  restoreShipmentAriaLabel: {
    defaultMessage: 'Restore Shipment section',
    description: 'Label for the section used to restore a shipment that was imported as shipped',
    id: '8UNyYL',
  },
});

export default messages;
